import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { Auth } from 'aws-amplify';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import {
  GridContainer,
  LeftGrid,
  NoteHeading,
  DataGridContainer,
} from '../../Episode.Styled';
import { dateFormat, EPISODE_ACTIVITIES_URL } from '../../../../constants';
import { getStopApi } from '../../../../services/StopApi/StopApi';
import ActivityDialog from './ActivityDialog';
import { activities } from '../../../../redux/episode/activitiesTab/episodeActivity/episodeActivitySlice';
import { getContactByUser } from '../../../Contact/services/contactsApi';
import PrintActivities from './print/PrintActivities';

const Activities = (props) => {
  const episodeHeaderData = props.episodeHeaderData;
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [open, setOpen] = useState(false);
  const [openPrint, setOpenPrint] = useState(false);
  const [activitiesForm, setActivitiesForm] = useState({
    isLoading: false,
    data: [],
    pageSize: 10,
    total: '',
    page: 1,
  });
  const activitiesRefernceData = useSelector(
    (state) => state?.activitiesRefernceData
  );
  const episode = useSelector(
    (state) => state?.episodeDetail?.singleEpisode[0]
  );

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken,
    activitiesForm.page,
    activitiesForm.pageSize,
  ]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then(function (user) {
        getContactByUser(user)
        .then(function (loggedInContact) {
          user.contact = loggedInContact
        })
        .catch(() => console.log('Not signed in'));;
        return user
      })
      .catch(() => console.log('Not signed in'));
  };

  const fetchData = async () => {
    //console.log('### user.contact.networkUserName')
    //console.log(user.contact.networkUserName)
    setActivitiesForm((prveState) => ({ ...prveState, isLoading: true }));
    const commonParams = `${EPISODE_ACTIVITIES_URL}/${episode.episodeId}/activities?PageNumber=${activitiesForm.page}&PageSize=${activitiesForm.pageSize}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    getStopApi({ commonParams, authorization }).then((response) => {
      const json = response.data;
      json.sort((a, b) => b.dateCompleted.localeCompare(a.dateCompleted));
      setActivitiesForm((prveState) => ({
        ...prveState,
        isLoading: false,
        total: response.totalRows,
        data: json?.map((item, index) => ({
          ...item,
          id: index,
          actId: item.actId ? item.actId : '-',
          dateCompleted: item.dateCompleted
            ? moment(item.dateCompleted).format(dateFormat).split('T')[0]
            : '-',
          dateEarly: item.dateEarly
            ? moment(item.dateEarly).format(dateFormat).split('T')[0]
            : '-',
          dateLate: item.dateLate
            ? moment(item.dateLate).format(dateFormat).split('T')[0]
            : '-',
          activityType: item.activityType?.value,
          activityWithContactType: item.activityWithContactType?.value,
          activityWithContactName: item.activityWithContactName?.value,
          activityByWestCareEmployee: item.activityByWestCareEmployee?.value,
          priority: item.priority?.value ? item.priority?.value : '-',
          Is12StepQuestionAsked: item.Is12StepQuestionAsked,
          Is12StepQuestionAnswered: item.Is12StepQuestionAnswered,
          recdCBPROI: item.recdCBPROI,
          unitQty: item.unitQty
        })),
      }));
    }).catch((e) => alert(e));
  };

  const activitiesRowClick = (rowData) => {
    const activityTypeIds = activitiesRefernceData?.activityTypes?.filter(
      (item) => (item.value === rowData.activityType ? item.id : '')
    );
    const activityTypeValues = {
      id: activityTypeIds[0]?.id,
      value: activityTypeIds[0]?.value,
    };

    const activityWithContactTypeIds =
      activitiesRefernceData?.contactTypes?.filter((item) =>
        item.value === rowData.activityWithContactType ? item.id : ''
      );
    const activityWithContactTypeValues = {
      id: activityWithContactTypeIds[0]?.id,
      value: activityWithContactTypeIds[0]?.value,
    };

    const activityWithContactNameIds =
      activitiesRefernceData?.activityWithList?.filter((item) =>
        item.value === rowData.activityWithContactName ? item.id : ''
      );
    const activityWithContactNameValues = {
      id: activityWithContactNameIds[0]?.id,
      value: activityWithContactNameIds[0]?.value,
    };

    const activityByWestCareEmployeeIds =
      activitiesRefernceData?.activityByList?.filter((item) =>
        item.value === rowData.activityByWestCareEmployee ? item.id : ''
      );
    const activityByWestCareEmployeeValues = {
      id: activityByWestCareEmployeeIds[0]?.id,
      value: activityByWestCareEmployeeIds[0]?.value,
    };

    const priorityIds = activitiesRefernceData?.priorities?.filter((item) =>
      item.value === rowData.priority ? item.id : ''
    );
    const priorityValues = {
      id: priorityIds[0]?.id,
      value: priorityIds[0]?.value,
    };

    const activitiesDetail = {
      activityNote: rowData.actNote,
      actId: rowData.actId,
      dateCompleted: rowData.dateCompleted,
      dateEarly: rowData.dateEarly,
      dateLate: rowData.dateLate,
      activityType: activityTypeValues,
      activityWithContactType: activityWithContactTypeValues,
      activityWithContactName: activityWithContactNameValues,
      activityByWestCareEmployee: activityByWestCareEmployeeValues,
      priority: priorityValues,
      Is12StepQuestionAsked: rowData.Is12StepQuestionAsked
        ? rowData.Is12StepQuestionAsked
        : false,
      Is12StepQuestionAnswered: rowData.Is12StepQuestionAnswered
        ? rowData.Is12StepQuestionAnswered
        : false,
      recdCBPROI: rowData.recdCBPROI ? rowData.recdCBPROI : false,
    };
    dispatch(activities(activitiesDetail));
    setOpen(true);
  };

  const openNewActivity = () => {
    const activitiesDetail = {
      newActivity: true,
      dateCompleted: '',
      dateEarly: '',
      dateLate: '',
      activityType: '',
      activityWithContactType: '',
      activityWithContactName: '',
      activityByWestCareEmployee: '',
      priority: '',
      Is12StepQuestionAsked: '',
      Is12StepQuestionAnswered: '',
      recdCBPROI: '',
    };
    dispatch(activities(activitiesDetail));
    setOpen(true);
  };

  const handleOpenPrint = () => {
    setOpenPrint(true);
  };

  const columnsData = [
    {
      field: 'actId',
      headerName: 'Activity Key',
      sortable: false,
      flex: 1,
      minWidth: 80,
    },
    {
      field: 'dateCompleted',
      headerName: 'Completed',
      sortable: false,
      flex: 1,
      type: 'date',
      minWidth: 80,
    },
    {
      field: 'dateEarly',
      headerName: 'Early',
      sortable: false,
      flex: 1,
      type: 'date',
      minWidth: 80,
    },
    {
      field: 'dateLate',
      headerName: 'Late',
      sortable: false,
      flex: 1,
      type: 'date',
      minWidth: 80,
    },
    {
      field: 'activityType',
      headerName: 'Activity Type',
      sortable: false,
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'activityWithContactType',
      headerName: 'Activity With Contact Type',
      sortable: false,
      flex: 1,
      minWidth: 120,
    },
    {
      field: 'activityWithContactName',
      headerName: 'Activity With Contact Name',
      sortable: false,
      flex: 1,
      minWidth: 140,
    },
    {
      field: 'activityByWestCareEmployee',
      headerName: 'Activity By West Care Employee',
      sortable: false,
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'priority',
      headerName: 'Priority',
      sortable: false,
      flex: 1,
      minWidth: 80,
    },
    {
      field: 'Is12StepQuestionAsked',
      headerName: 'Is 12 Step Question Asked',
      sortable: false,
      flex: 1,
      valueGetter: (params) => {
        if (params.value) {
          return 'Yes';
        }
        return 'No';
      },
    },
    {
      field: 'Is12StepQuestionAnswered',
      headerName: 'Is 12 Step Question Answered',
      sortable: false,
      flex: 1,
      valueGetter: (params) => {
        if (params.value) {
          return 'Yes';
        }
        return 'No';
      },
    },
    {
      field: 'recdCBPROI',
      headerName: `Rec'd CBP ROI`,
      sortable: false,
      flex: 1,
      valueGetter: (params) => {
        if (params.value) {
          return 'Yes';
        }
        return 'No';
      },
    },
  ];

  return (
    <>
      <GridContainer container>
        <Grid item xs={6}>
          <NoteHeading variant='h5'>
            Click row to view/edit activity record
          </NoteHeading>
        </Grid>
        <LeftGrid item xs={6}>
          <Button variant='contained' onClick={() => handleOpenPrint()}>
            Print Preview
          </Button>&nbsp;
          <Button variant='contained' onClick={() => openNewActivity()}>
            New Activity
          </Button>
        </LeftGrid>
      </GridContainer>
      <DataGridContainer>
      <div style={{ height: 670, width: '100%' }}>
        <div style={{ display: 'flex', height: '100%' }}>
          <div style={{ flexGrow: 1 }}>
            <DataGrid
              //getRowHeight={() => 'auto'}
              columns={columnsData}
              rows={activitiesForm.data}
              rowCount={activitiesForm.total}
              rowsPerPageOptions={[10, 25, 50]}
              pageSize={activitiesForm.pageSize}
              pagination
              paginationMode='server'
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
              }
              onPageSizeChange={(newPageSize) =>
                setActivitiesForm((old) => ({ ...old, pageSize: newPageSize }))
              }
              onPageChange={(newPage) => {
                setActivitiesForm((old) => ({ ...old, page: newPage + 1 }));
              }}
              loading={activitiesForm.isLoading}
              onRowClick={(param) => activitiesRowClick(param.row)}
              disableColumnFilter
              disableColumnMenu
            />
          </div>
        </div>
      </div>      
      </DataGridContainer>
      <ActivityDialog
        open={open}
        setOpen={setOpen}
        authToken={user?.signInUserSession.accessToken.jwtToken}
        episodeId={episode.episodeId}
        fetchData={fetchData}
        networkUserName={user?.contact?.networkUserName}
        episodeHeaderData = {episodeHeaderData}
      />
      <PrintActivities
        open={openPrint}
        setOpen={setOpenPrint}
        episode={episode}
        activities={activitiesForm.data}
      />
    </>
  );
};
export default Activities;
